import Vue from "vue";
import Router from "vue-router";
import Meta from "vue-meta";
import Home from "./views/homepage/Homepage.vue";
import SiteMap from "./views/Sitemap/Sitemap.vue";
import NotFound from "./views/notFound/NotFound.vue";
import NavBar from "./components/NavBar.vue";
import NavBar2 from "./components/NavBarv2.vue";
import Footer from "./components/Footer.vue";
import AppLayout from "./components/admin/AppLayout";
import NProgress from "nprogress";
Vue.use(Router);
Vue.use(Meta);

const router = new Router({ 
	mode: "history",
	// scrollBehavior,
	base: process.env.BASE_URL,
	routes: [
		// {
		//   path: "/",
		//   name: "home",
		//   component: Home
		// },
		// {
		//   path: "/about",
		//   name: "about",
		//   // route level code-splitting
		//   // this generates a separate chunk (about.[hash].js) for this route
		//   // which is lazy-loaded when the route is visited.
		//   component: () =>
		//     import(/* webpackChunkName: "about" */ "./views/About.vue")
		// },
		// {
		// 	path: "/",
		// 	name: "Index",
		// 	component: () => import("./views/Index.vue")
		// },
		{
			path: "/inventory-account-setup",
			name: "InventoryAccountSetup",
			component: () =>
				import("./views/inventoryAccountSetup/InventoryAccountSetup.vue"),
			// props: true
		},
		{
			path: "/project-report-pdf",
			name: "ProjectReportPdf",
			component: () =>
				import(
					"./components/UI/pdf/ProjectReportPdf.vue"
				),
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/admin",
			name: "Admin",
			component: AppLayout,
			children: [
				{
					path: "sales-dd",
					name: "SalesDD",
					component: () =>
						import("./components/admin/appSalesDropdown/AppSalesDropdown.vue"),
					children: [
						{
							path: "location",
							name: "Location",
							component: () =>
								import(
									"./components/admin/appSalesLocation/appSalesLocation.vue"
								),
							meta: {
								requiresAuth: true,
							},
						},
						{
							path: "category",
							name: "Category",
							component: () =>
								import(
									"./components/admin/appSalesCategory/appSalesCategory.vue"
								),
							meta: {
								requiresAuth: true,
							},
						},
						{
							path: "sales-store-type",
							name: "SalesStoreType",
							component: () =>
								import(
									"./components/admin/appSalesStoreType/appSalesStoreType.vue"
								),
							meta: {
								requiresAuth: true,
							},
						},
						{
							path: "sales-order-type",
							name: "SalesOrderType",
							component: () =>
								import(
									"./components/admin/appSalesOrderType/appSalesOrderType.vue"
								),
							meta: {
								requiresAuth: true,
							},
						},
						{
							path: "/account-setup",
							name: "AccountSetup",
							component: () => import("./views/accountSetup/AccountSetup.vue"),
							meta: {
								requiresAuth: true,
							},
						},
						{
							path: "/app-upload-csv-or-add-store-details",
							name: "AppUploadCsvOrAddStoreDetails",
							component: () =>
								import(
									"./components/admin/appUploadCsvOrAddStoreDetails/appuploadCsvOrAddStoreDetails.vue"
								),
							meta: {
								requiresAuth: true,
							},
						},
						{
							path: "/nymble-dashboard/:pageName",
							name: "NymbleDashboard",
							component: () =>
								import("./views/nymbleDashboard/NymbleDashboard.vue"),
							props: true,
							meta: {
								requiresAuth: true,
							},
						},
						{
							path: "/upload-article-master",
							name: "UploadArticleMaster",
							component: () =>
								import(
									"./components/admin/appItemMaster/uploadArticleMaster/UploadArticleMaster.vue"
								),
							meta: {
								requiresAuth: true,
							},
						},
						{
							path: "edit-item-master",
							name: "EditArticleMaster",
							component: () =>
								import(
									"./components/admin/appItemMaster/editArticleMaster/EditArticleMaster.vue"
								),
							meta: {
								requiresAuth: true,
							},
						},
						{
							path: "add-item-master",
							name: "AddArticleMaster",
							component: () =>
								import(
									"./components/admin/appItemMaster/addArticleMaster/AddAticleMaster.vue"
								),
							meta: {
								requiresAuth: true,
							},
						},
						{
							path: "/upload-hist-sales",
							name: "UploadHistSales",
							component: () =>
								import(
									"./components/admin/appEditSalesData/uploadHistSales/UploadHistSales.vue"
								),
							meta: {
								requiresAuth: true,
							},
						},
						{
							path: "/edit-delete-hist-sales",
							name: "EditDeleteHistSales",
							component: () =>
								import(
									"./components/admin/appEditSalesData/editDeleteHistSales/EditDeleteHistSales.vue"
								),
							meta: {
								requiresAuth: true,
							},
						},
					],
				},
				{
					path: "campaign",
					name: "Campaign",
					component: () =>
						import(
							"./components/admin/campaign/campaignDashboard/CampaignDashboard.vue"
						),
					meta: {
						requiresAuth: true,
					},
				},
				{
					path: "create-campaign/:storeId?",
					name: "CreateCampaign",
					component: () =>
						import(
							"./components/admin/campaign/createCampaign/CreateCampaign.vue"
						),
					props: true,
					meta: {
						requiresAuth: true,
					},
				},
				{
					path: "sales-forecast-dd",
					name: "SalesForecastDD",
					component: () =>
						import(
							"./components/admin/appForecastDropdown/AppSalesForecastDropdown.vue"
						),
					meta: {
						requiresAuth: true,
					},
					children: [
						{
							path: "forecast-location",
							name: "forecastLocation",
							component: () =>
								import(
									"./components/admin/appForecastLocation/AppForecastLocation.vue"
								),
							meta: {
								requiresAuth: true,
							},
						},
						{
							path: "forecast-category",
							name: "forecastCategory",
							component: () =>
								import(
									"./components/admin/appForecastCategory/AppForecastCategory.vue"
								),
							meta: {
								requiresAuth: true,
							},
						},
						{
							path: "forecast-central-kitchen",
							name: "forecastCentralKitchen",
							component: () =>
								import(
									"./components/appForecastCentralKitchen/appForecastCentralKitchen.vue"
								),
							meta: {
								requiresAuth: true,
							},
						},
						// {
						// 	path: "/app-detailed-forcast",
						// 	name: "AppDetailedForcast",
						// 	component: () =>
						// 		import("./components/admin/appDetailedForcast/AppDetailedForcast.vue")
						// }
					],
				},
				{	
					path: "production",
					name: "Production",
					component: () =>
						import(
							"./views/V2UI/ProductionDashboard.vue"
						),
					meta: {
						requiresAuth: true,
					}
				},
				{
					path: "production/thaw-chart",
					name: "ProductionThawChart",
					component: () =>
						import(
							"./components/UI/page/ProductionThawChart.vue"
						),
					meta: {
						requiresAuth: true,
					},
				},
				{
					path: "sales-forecast",
					name: "SalesForecast",
					component: () => import("./views/V2UI/SalesForecastView.vue"),
					meta: {
						requiresAuth: true,
					},
					children: [
						{
							path: "location",
							name: "SalesLocationForecast",
							component: () =>
								import("./components/UI/sections/SalesForecastByLocation.vue"),
							meta: {
								requiresAuth: true,
							},
							props: true,
						},
						{
							path: "category",
							name: "SalesCategoryForecast",
							component: () =>
								import("./components/UI/sections/SalesForecastByCategory.vue"),
							meta: {
								requiresAuth: true,
							},
							props: true,
						},
						// {
						// 	path: "forecast-category",
						// 	name: "forecastCategory",
						// 	component: () => import("./components/admin/appForecastCategory/AppForecastCategory.vue"),
						// 	meta: {
						// 		requiresAuth: true,
						// 	},
						// },
						// {
						// 	path: "forecast-central-kitchen",
						// 	name: "forecastCentralKitchen",
						// 	component: () => import("./components/appForecastCentralKitchen/appForecastCentralKitchen.vue"),
						// 	meta: {
						// 		requiresAuth: true,
						// 	},
						// }
					],
				},
				{
					path: "inventory-dd",
					name: "InventoryDD",
					component: () =>
						import(
							"./components/admin/inventory/inventoryDropdown/InventoryDropdown.vue"
						),
					meta: {
						requiresAuth: true,
					},
					children: [
						{
							path: "inventory-disabled/:type?",
							name: "InventoryDisabled",
							component: () =>
								import(
									"./components/admin/inventory/inventoryDisabled/InventoryDisabled.vue"
								),
							props: true,
							meta: {
								requiresAuth: true,
							},
						},
						{
							path: "inventory-dashboard",
							name: "InventoryDashboard",
							component: () =>
								import(
									"./components/admin/inventory/inventoryDashboard/InventoryDashboard.vue"
								),
							meta: {
								requiresAuth: true,
							},
						},
						{
							path: "store-inventory",
							name: "StoreInventory",
							component: () =>
								import(
									"./components/admin/inventory/storeInventory/StoreInventory.vue"
								),
							meta: {
								requiresAuth: true,
							},
						},
						{
							path: "stock-calendar",
							name: "StockCalendar",
							component: () =>
								import(
									"./components/admin/inventory/stockCalendar/StockCalendar.vue"
								),
							meta: {
								requiresAuth: true,
							},
						},
						{
							path: "stock-count-stores",
							name: "StockCountStores",
							component: () =>
								import(
									"./components/admin/inventory/stockCountStores/StockCountStores.vue"
								),
							meta: {
								requiresAuth: true,
							},
						},
						{
							path: "stock-count-deliveries",
							name: "StockCountDeliveries",
							component: () =>
								import(
									"./components/admin/inventory/stockCountDeliveries/StockCountDeliveries.vue"
								),
							meta: {
								requiresAuth: true,
							},
						},
						{
							path: "wastage-count",
							name: "WastageCount",
							component: () =>
								import(
									"./components/admin/inventory/wastageCount/WastageCount.vue"
								),
							meta: {
								requiresAuth: true,
							},
						},
						{
							path: "warehouse-delivery",
							name: "WarehouseDelivery",
							component: () =>
								import(
									"./components/admin/inventory/warehouseDelivery/WarehouseDelivery"
								),
							meta: {
								requiresAuth: true,
							},
						},
						{
							path: "edit-recipe",
							name: "EditRecipe",
							component: () =>
								import(
									"./components/admin/inventory/recipeBuild/editRecipe/EditRecipe.vue"
								),
							meta: {
								requiresAuth: true,
							},
						},
						{
							path: "create-recipe",
							name: "CreateRecipe",
							component: () =>
								import(
									"./components/admin/inventory/recipeBuild/createRecipe/CreateRecipe.vue"
								),
							meta: {
								requiresAuth: true,
							},
						},
						{
							path: "upload-recipe-csv",
							name: "UploadRecipe",
							component: () =>
								import(
									"./components/admin/inventory/recipeBuild/uploadRecipe/UploadRecipe.vue"
								),
							meta: {
								requiresAuth: true,
							},
						},
						{
							// path: "new-order",
							path: "planned-indents",
							name: "NewOrder",
							component: () =>
								import("./components/admin/inventory/newOrder/NewOrder.vue"),
							meta: {
								requiresAuth: true,
							},
						},
						{
							path: "sent-order",
							name: "SentOrder",
							component: () =>
								import("./components/admin/inventory/sentOrder/SentOrder.vue"),
							props: true,
							meta: {
								requiresAuth: true,
							},
						},
						{
							path: "internal-supplier",
							name: "InternalSupplier",
							component: () =>
								import(
									"./components/admin/inventory/supplier/internalSupplier/InternalSupplier.vue"
								),
							meta: {
								requiresAuth: true,
							},
						},
						{
							path: "external-supplier",
							name: "ExternalSupplier",
							component: () =>
								import(
									"./components/admin/inventory/supplier/externalSupplier/ExternalSupplier.vue"
								),
							meta: {
								requiresAuth: true,
							},
						},
						{
							path: "view-edit-product",
							name: "ViewEditProduct",
							component: () =>
								import(
									"./components/admin/inventory/supplier/viewEditProduct/ViewEditProduct.vue"
								),
							meta: {
								requiresAuth: true,
							},
							// children: [
							// 	{
							// 		path: "/edit-product",
							// 		name: "EditProduct",
							// 		component: () =>
							// 			import("./components/admin/inventory/supplier/viewEditProduct/editProduct/EditProduct.vue")
							// 	},
							// 	{
							// 		path: "add-product",
							// 		name: "AddProduct",
							// 		component: () =>
							// 			import("./components/admin/inventory/supplier/viewEditProduct/addProduct/AddProduct.vue")
							// 	}
							// ]
						},
						{
							path: "new-order-ho",
							name: "NewOrderHOCentralised",
							component: () =>
								import(
									"./components/admin/inventory/newOrderHOCentralised/NewOrderHOCentralised.vue"
								),
							meta: {
								requiresAuth: true,
							},
						},
						{
							path: "new-order-ho-v2",
							name: "NewOrderHOV2",
							component: () =>
								import(
									"./components/admin/inventory/newOrderHOCentralised/NewOrderHOV2.vue"
								),
							meta: {
								requiresAuth: true,
							},
						},
						{
							path: "upload-current-stock",
							name: "UploadCurrentStock",
							component: () =>
								import(
									"./components/admin/inventory/uploadCurrentStock/UploadCurrentStock.vue"
								),
							meta: {
								requiresAuth: true,
							},
						},
					],
				},

				{
					path: "labour-planing-dd",
					name: "LabourPlaningDD",
					component: () =>
						import(
							"./components/admin/labourPlaninig/labourPlaningDropdown/LabourPlaningDropdown.vue"
						),
					meta: {
						requiresAuth: true,
					},
					children: [
						// {
						// 	path: "store-inventory",
						// 	name: "StoreInventory",
						// 	component: () =>
						// 		import("./components/admin/inventory/storeInventory/StoreInventory.vue")
						// },
						{
							path: "/schedule-planner/:weekoff?",
							name: "SchedulePlanner",
							component: () =>
								import(
									"./components/admin/labourPlaninig/schedulePlanner/SchedulePlanner.vue"
								),
							props(route) {
								return route.params || {};
							},
							meta: {
								requiresAuth: true,
							},
						},
						{
							path: "/month-wise-scheduler/",
							name: "MonthlySchedulePlanner",
							component: () =>
								import(
									"./components/admin/labourPlaninig/monthWiseScheduler/MonthlySchedulerPlanner.vue"
								),
							props(route) {
								return route.params || {};
							},
							meta: {
								requiresAuth: true,
							},
						},
						{
							path: "/cluster/",
							name: "Cluster",
							component: () =>
								import("./components/admin/labourPlaninig/cluster/Cluster.vue"),
							props(route) {
								return route.params || {};
							},
							meta: {
								requiresAuth: true,
							},
						},
						{
							path: "/timesheet",
							name: "Timesheet",
							component: () =>
								import("./components/admin/timeSheet/Timesheet.vue"),
							props(route) {
								return route.params || {};
							},
							meta: {
								requiresAuth: true,
							},
						},
						{
							path: "/sales-forecast",
							name: "salesForecastV2",
							component: () =>
								import("./views/V2UI/SalesForecast.vue"),
							props(route) {
								return route.params || {};
							},
							meta: {
								requiresAuth: true,
							},
							props: true,
						},
						{
							path: "/labour-planning-dashboard",
							name: "LabourPlaningDashboard",
							component: () =>
								import(
									"./components/admin/labourPlaninig/labourPlanningDashboard/LabourPlaningDashboard.vue"
								),
							meta: {
								requiresAuth: true,
							},
						},
						{
							path: "/ADT-And-IPT-Details/:storeName?/:date?/:adtIptDialog?",
							name: "ADTAndIPTDetails",
							component: () =>
								import(
									"./components/admin/labourPlaninig/schedulePlanner/adtAndIptDetails/ADTAndIPTDetails.vue"
								),
							props(route) {
								return route.params || {};
							},
							meta: {
								requiresAuth: true,
							},
						},
						{
							path: "/actual-summary/:storeName?/:date?",
							name: "ActualSummary",
							component: () =>
								import(
									"./components/admin/labourPlaninig/schedulePlanner/actualSummary/ActualSummary.vue"
								),
							props(route) {
								return route.params || {};
							},
							meta: {
								requiresAuth: true,
							},
						},
						{
							path: "/day-wise-scheduler/:storeId?/:date?",
							name: "DayWiseScheduler",
							component: () =>
								import(
									"./components/admin/labourPlaninig/dayWiseScheduler/DayWiseScheduler.vue"
								),
							props: true,
							meta: {
								requiresAuth: true,
							},
						},
						{
							path: "/workspace-planning",
							name: "WorkspacePlanning",
							component: () =>
								import(
									"./components/admin/labourPlaninig/workspacePlanning/WorkspacePlanning.vue"
								),
							meta: {
								requiresAuth: true,
							},
						},
						{
							path: "/training-calendar",
							name: "TrainingCalendar",
							component: () =>
								import(
									"./views/V2UI/TrainingCalendar.vue"
								),
							meta: {
								requiresAuth: true,
							},
						},
						{
							path: "/report",
							name: "Report",
							component: () =>
								import("./components/admin/labourPlaninig/report/Report.vue"),
							meta: {
								requiresAuth: true,
							},
						},
						{
							path: "/ideal-schedule-report",
							name: "IdealScheduleReport",
							component: () =>
								import(
									"./components/admin/labourPlaninig/idealScheduleReport/IdealScheduleReport.vue"
								),
							meta: {
								requiresAuth: true,
							},
						},
						{
							path: "/sales-Labour-report",
							name: "SalesLabourReport",
							component: () =>
								import(
									"./components/admin/labourPlaninig/salesLabourReport/SalesLabourReport.vue"
								),
							meta: {
								requiresAuth: true,
							},
						},
						{
							path: "/store-type",
							name: "StoreType",
							component: () =>
								import(
									"./components/admin/labourPlaninig/storeType/StoreType.vue"
								),
							meta: {
								requiresAuth: true,
							},
						},
						{
							path: "/performance",
							name: "Performance",
							component: () =>
								import(
									"./components/admin/labourPlaninig/Performance/Performance.vue"
								),
							meta: {
								requiresAuth: true,
							},
						},
						{
							path: "/schedule-planner-table-print",
							name: "SchedulePlannerTablePrint",
							component: () =>
								import(
									"./components/admin/labourPlaninig/schedulePlanner/schedulePlannerTablePrint/SchedulePlannerTablePrint.vue"
								),
							meta: {
								requiresAuth: true,
							},
						},
						{
							path: "tasks",
							name: "Tasks",
							component: () =>
								import("./components/admin/labourPlaninig/tasks/Tasks.vue"),
							meta: {
								requiresAuth: true,
							},
						},
						{
							path: "/admin/tasks",
							name: "ChildPages",
							component: () =>
								import(
									"./components/admin/V2FormBuilder/V2Projects/ChildPages.vue"
								),
							meta: {
								requiresAuth: true,
							},
						},
						{
							path: "/NewDashboard",
							name: "NewDashboard",
							component: () =>
								import(
									"./components/admin/V2FormBuilder/V2NewDashboard/Dashboard.vue"
								),
							meta: {
								requiresAuth: true,
							},
						},
						{
							path: "/license-management",
							name: "license-management",
							component: () =>
								import(
									"./components/admin/LicenseManagement/LicenseManagement.vue"
								),
							meta: {
								requiresAuth: true,
							},
						},
						{
							path: "/FormBuilder",
							name: "V2FormBuilder",
							component: () =>
								import("./components/admin/V2FormBuilder/FormLists.vue"),
							meta: {
								requiresAuth: true,
							},
						},
						{
							path: "report-details",
							name: "ReportDetails",
							component: () =>
								import(
									"./components/admin/labourPlaninig/storeSettings/reportDetails/ReportDetails.vue"
								),
							meta: {
								requiresAuth: true,
							},
						},
						{
							path: "/user-groups",
							name: "UsersAndGroups",
							component: () => import("./views/V2UI/UsersAndGroups.vue"),
							meta: {
								requiresAuth: true,
							},
						},
						{
							path: "/user-group/add",
							name: "AddUserGroup",
							component: () =>
								import("./components/UI/sections/AddUpdateUserGroup.vue"),
							meta: {
								requiresAuth: true,
							},
						},
						{
							path: "/user-group/edit/:id?",
							name: "UpdateUserGroup",
							component: () =>
								import("./components/UI/sections/AddUpdateUserGroup.vue"),
							meta: {
								requiresAuth: true,
							},
						},
						{
							path: "/orders",
							name: "Orders",
							component: () =>
								import("./views/V2UI/Orders.vue"),
							meta: {
								requiresAuth: true,
							},
						},
						{
							path: "settings",
							name: "Settings",
							component: () =>
								import(
									"./components/admin/labourPlaninig/settings/Settings.vue"
								),
							meta: {
								requiresAuth: true,
							},
							children: [
								{
									path: "company",
									name: "Company",
									component: () =>
										import(
											"./components/admin/labourPlaninig/settings/companySettings/companySettings.vue"
										),
									meta: {
										requiresAuth: true,
									},
								},
								{
									path: "store",
									name: "Store",
									component: () =>
										import(
											"./components/admin/labourPlaninig/settings/storeSettings/StoreSettings.vue"
										),
									meta: {
										requiresAuth: true,
									},
								},
							],
						},
						{
							path: "store-settings",
							name: "StoreSettings",
							component: () =>
								import(
									"./components/admin/labourPlaninig/storeSettings/StoreSettings.vue"
								),
							meta: {
								requiresAuth: true,
							},
							children: [
								{
									path: "store-details",
									name: "StoreDetails",
									component: () =>
										import(
											"./components/admin/labourPlaninig/storeSettings/storeDetails/StoreDetails.vue"
										),
									meta: {
										requiresAuth: true,
									},
								},
								{
									path: "staff",
									name: "Staff",
									component: () =>
										import(
											"./components/admin/labourPlaninig/storeSettings/staff/Staff.vue"
										),
									meta: {
										requiresAuth: true,
									},
								},
								{
									path: "team",
									name: "Team",
									component: () =>
										import(
											"./components/admin/labourPlaninig/storeSettings/staff/Team.vue"
										),
									meta: {
										requiresAuth: true,
									},
								},
								{
									path: "work-area",
									name: "WorkArea",
									component: () =>
										import(
											"./components/admin/labourPlaninig/storeSettings/workArea/WorkArea.vue"
										),
									meta: {
										requiresAuth: true,
									},
								},
								{
									path: "activities",
									name: "Activities",
									component: () =>
										import(
											"./components/admin/labourPlaninig/storeSettings/activities/Activities.vue"
										),
									meta: {
										requiresAuth: true,
									},
								},
								{
									path: "target",
									name: "Target",
									component: () =>
										import(
											"./components/admin/labourPlaninig/storeSettings/target/Target.vue"
										),
									meta: {
										requiresAuth: true,
									},
								},
								{
									path: "tasks",
									name: "StoreTasks",
									component: () =>
										import(
											"./components/admin/labourPlaninig/storeSettings/tasks/Tasks.vue"
										),
									meta: {
										requiresAuth: true,
									},
								},
							],
						},
					],
				},
				{
					path: "tickets",
					name: "Tickets",
					component: () =>
						import("./components/admin/ticketManagement/Tickets.vue"),
					meta: {
						requiresAuth: true,
					},
				},
				{
					path: "tickets-template",
					name: "TicketsTemplate",
					component: () =>
						import("./components/admin/ticketManagement/TicketTemplate.vue"),
					meta: {
						requiresAuth: true,
					},
				},
				{
					path: "tickets-dashboard",
					name: "TicketsDashboard",
					component: () =>
						import("./components/admin/ticketManagement/TicketsDashboard.vue"),
					meta: {
						requiresAuth: true,
					},
				},

				{
					path: "expiry-management",
					name: "ExpiryMgt",
					component: () =>
						import(
							"./components/admin/expiryManagement/expiryDropdown/ExpiryDropDown.vue"
						),
					meta: {
						requiresAuth: true,
					},
					children: [
						{
							path: "expiry-dashboard",
							name: "ExpiryDashboard",
							component: () =>
								import(
									"./components/admin/expiryManagement/expiryDashboard/ExpiryDashboard.vue"
								),
							meta: {
								requiresAuth: true,
							},
						},
						{
							path: "expiry-alert-list",
							name: "ExpiryAlertList",
							component: () =>
								import(
									"./components/admin/expiryManagement/expiryAlertList/ExpiryAlertList.vue"
								),
							meta: {
								requiresAuth: true,
							},
						},
						{
							path: "expiry-alert",
							name: "ExpiryAlert",
							component: () =>
								import(
									"./components/admin/expiryManagement/expiryAlert/ExpiryAlert.vue"
								),
							meta: {
								requiresAuth: true,
							},
						},
					],
				},

				{
					path: "/account-setup-v2",
					name: "AccountSetupV2",
					component: () =>
						import("./components/accountSetupV2/AccountSetupV2.vue"),
					meta: {
						requiresAuth: true,
					},
				},
				{
					path: "/locations",
					name: "locations",
					component: () =>
						import("./components/admin/v2Location/LocationSettings.vue"),
					meta: {
						requiresAuth: true,
					},
				},
				{
					path: "/locationsD",
					name: "locationsD",
					component: () => import("./components/admin/v2Location/Locations/LocationsDialog.vue"),
					meta: {
						requiresAuth: true,
					},
				},
				{
					path: "/AddEditLocations/:id",
					name: "AddEditLocations",
					component: () => import("./components/admin/v2Location/Locations/AddEditLocations.vue"),
					meta: {
						requiresAuth: true,
					},
				},
				{
					path: "/app-store-details",
					name: "AppStoreDetails",
					component: () =>
						import("./components/admin/appStoreDetails/AppStoreDetails.vue"),
					meta: {
						requiresAuth: true,
					},
				},
				{
					path: "/account/:type",
					name: "AddAccount",
					component: () =>
						import("./components/admin/appAddStore/AppAddStore.vue"),
					props: true,
					meta: {
						requiresAuth: true,
					},
				},
				{
					path: "/test-account/:type",
					name: "TestAddAccount",
					component: () =>
						import("./components/admin/appAddStore/TestAddStore.vue"),
					props: true,
					meta: {
						requiresAuth: true,
					},
				},
				{
					path: "/create-cluster",
					name: "CreateCluster",
					component: () =>
						import("./components/admin/createCluster/CreateCluster.vue"),
					props: true,
					meta: {
						requiresAuth: true,
					},
				},
				{
					path: "/events",
					name: "EventList",
					component: () =>
						import("./components/admin/events/eventsList/EventList.vue"),
					meta: {
						requiresAuth: true,
					},
				},
				{
					path: "/targets",
					name: "Targets",
					component: () => import("./components/admin/targets/Targets.vue"),
					meta: {
						requiresAuth: true,
					},
				},
				{
					path: "/notifications",
					name: "Notifications",
					component: () =>
						import("./components/admin/notifications/Notifications.vue"),
					meta: {
						requiresAuth: true,
					},
				},
				{
					path: "/single-store",
					name: "SingleStoreData",
					component: () =>
						import("./components/admin/singleStoreData/SingleStoreData.vue"),
					meta: {
						requiresAuth: true,
					},
				},
				{
					path: "/workforce-dashboard",
					name: "WrokForceDashboard",
					component: () =>
						import(
							"./components/admin/workforceDashboard/WrokForceDashboard.vue"
						),
					meta: {
						requiresAuth: true,
					},
				},
				{
					path: "/multiple-store",
					name: "MultipleStoreData",
					component: () =>
						import(
							"./components/admin/multipleStoreData/MultipleStoreData.vue"
						),
					meta: {
						requiresAuth: true,
					},
				},
				{
					path: "/account/:accountId/:type?",
					name: "EditAccount",
					component: () =>
						import("./components/admin/appAddStore/AppAddStore.vue"),
					props: true,
					meta: {
						requiresAuth: true,
					},
				},
				{
					path: "/app-update-store/:type?",
					name: "AppUpdateStore",
					component: () =>
						import("./components/admin/appUpdateStore/AppUpdateStore.vue"),
					props: true,
					meta: {
						requiresAuth: true,
					},
				},
				{
					path: "app-user-permissions",
					name: "AppUserPermissions",
					component: () =>
						import(
							"./components/admin/appUserPermissions/AppUserPermissions.vue"
						),
					meta: {
						requiresAuth: true,
					},
				},
				{
					path: "/support",
					name: "Support",
					component: () => import("./components/admin/support/Support.vue"),
					// component:()=> import('./components/admin/ticketManagement/Tickets.vue'),
					meta: {
						requiresAuth: true,
					},
				},
				{
					path: "/support-v2",
					name: "support-v2",
					// component: () => import("./components/admin/support/Support.vue"),
					component:()=> import('./components/admin/ticketManagement/Tickets.vue'),
					meta: {
						requiresAuth: true,
					},
				},
			],
		},
		{	
			path: "/generate/audit/report",
			name: "AuditReport",
			component: () =>
				import(
					"./views/V2UI/GenerateAuditReport.vue"
				),
			meta: {
				requiresAuth: false,
			},
			props(route) {
				return route.params || {};
			},
		},
		{	
			path: "/generate/action/report",
			name: "ActionReport",
			component: () =>
				import(
					"./views/V2UI/GenerateActionReport.vue"
				),
			meta: {
				requiresAuth: false,
			},
			props(route) {
				return route.params || {};
			},
		},
		{
			path: "/",
			name: "Home",
			component: Home,
		},
		{
			path: "/sitemap",
			name: "SiteMap",
			component: SiteMap,
		},
		{
			path: "/navbar",
			name: "NavBar",
			component: NavBar,
		},
		{
			path: "/navbar_v2",
			name: "NavBar2",
			component: NavBar2,
		},
		// {
		// 	path: "/login_v1",
		// 	name: "Login",
		// 	component: () => import("./views/login/Login.vue")
		// },
		{
			path: "/login_v2",
			name: "Login1",
			component: () => import("./views/login1/Login1.vue"),
		},
		{
			path: "/forgot-password",
			name: "ForgotPassword",
			component: () => import("./views/forgotPassword/ForgotPassword.vue"),
		},
		{
			path: "/reset-password",
			name: "ResetPassword",
			component: () => import("./views/resetPassword/ResetPassword.vue"),
		},
		{
			path: "/footer",
			name: "Footer",
			component: Footer,
		},
		{
			path: "/customers",
			name: "Customers",
			component: () => import("./views/customers/Customers.vue"),
		},
		{
			path: "/about-us",
			name: "Aboutus",
			component: () => import("./views/aboutus/Aboutus.vue"),
		},
		{
			path: "/videos",
			name: "VideoPage",
			component: () => import("./views/videoPage/videoPage.vue"),
		},
		{
			path: "/workforce-scheduling",
			name: "workForceScheduling",
			component: () =>
				import("./views/workForceScheduling/WorkForceScheduling.vue"),
		},
		{
			path: "/ai-forecasting-and-reco-engine",
			name: "aiForecasting&RecommendationEngine",
			component: () =>
				import(
					"./views/aiForecasting&RecommendationEngine/AiForecasting&RecommendationEngine.vue"
				),
		},
		{
			path: "/demand-planning",
			name: "demandPlanning",
			component: () => import("./views/demandPlanning/DemandPlanning.vue"),
		},
		{
			path: "/privacy-policy",
			name: "Privacy&policy",
			component: () => import("./views/PrivacePolicy/PrivacePolicy.vue"),
		},
		{
			path: "/terms-of-service",
			name: "TermsOfService",
			component: () => import("./views/termsOfService/TermsOfService.vue"),
		},
		{
			path: "/request-demo",
			name: "ContactUsRequestDemo",
			component: () =>
				import("./views/contactUsRequestDemo/ContactUsRequestDemo.vue"),
		},
		{
			path: "/email-template",
			name: "EmailTemplate",
			component: () => import("./views/emailTemplate/EmailTemplate.vue"),
		},
		{
			path: "/account-setting-navbar",
			name: "AccountSettingNavBar",
			component: () => import("./components/AccountSettingNavBar.vue"),
		},
		{
			path: "/user-information",
			name: "UserInformation",
			component: () => import("./views/userInformation/UserInformation.vue"),
		},
		{
			path: "/account-type",
			name: "AccountType",
			component: () => import("./views/accountType/AccountType.vue"),
		},
		{
			path: "/resources",
			name: "Resources",
			component: () => import("./views/resources/Resources.vue"),
		},
		{
			path: "/finish-setup",
			name: "FinishSetUp",
			component: () => import("./views/finishSetUp/FinishSetUp"),
		},
		{
			path: "/sales-forecast",
			name: "SalesForecast",
			component: () => import("./views/salesForecast/SalesForecast.vue"),
		},
		{
			path: "/inventory-management",
			name: "InventoryManagement",
			component: () =>
				import("./views/inventoryManagement/InventoryManagement.vue"),
		},
		{
			path: "/expiry-management",
			name: "ExpiryManagement",
			component: () => import("./views/expiryManagement/ExpiryManagement.vue"),
		},
		{
			path: "/login-and-free-trial",
			name: "LoginAndFreeTrial",
			component: () =>
				import("./components/loginAndFreeTrial/LoginAndFreeTrial.vue"),
		},
		{
			path: "/echarts-example",
			name: "Echarts example",
			component: () => import("./components/Echarts_example.vue"),
		},
		{
			path: "/app-nav-bar",
			name: "AppNavBar",
			component: () => import("./components/admin/appNavBar/AppNavBar.vue"),
		},

		{
			path: "/app-sales-tab",
			name: "AppSalesTab",
			component: () => import("./components/admin/appSalesTab/AppSalesTab.vue"),
		},
		{
			path: "/app-detailed-forcast",
			name: "AppDetailedForcast",
			component: () =>
				import("./components/admin/appDetailedForcast/AppDetailedForcast.vue"),
		},
		{
			path: "/app-marketing-event",
			name: "AppMarketingEvent",
			component: () =>
				import("./components/admin/appMarketingEvent/AppMarketingEvent.vue"),
		},
		{
			path: "/app-product-launch",
			name: "AppProductLaunch",
			component: () =>
				import("./components/admin/appProductLaunch/AppProductLaunch.vue"),
		},
		{
			path: "/app-sales-performance-card",
			name: "AppSalesPerformanceCard",
			component: () =>
				import(
					"./components/admin/appSalesPerformanceCard/AppSalesPerformanceCard.vue"
				),
		},
		{
			path: "/app-stock-count-calendar",
			name: "AppStockCountCalendar",
			component: () =>
				import(
					"./components/admin/appStockCountCalendar/AppStockCountCalendar.vue"
				),
		},
		{
			path: "/app-upload-stock-count",
			name: "AppUploadStockCount",
			component: () =>
				import(
					"./components/admin/appUploadStockCount/AppUploadStockCount.vue"
				),
		},
		{
			path: "/account-setting-nav-bar",
			component: () => import("./components/AccountSettingNavBar.vue"),
		},
		{
			path: "/account-information",
			name: "AccountInformation",
			component: () =>
				import("./views/accountInformation/AccountInformation.vue"),
		},
		{
			path: "/user-registration",
			name: "UserRegistration",
			component: () => import("./views/userRegistration/UserRegistration.vue"),
			children: [
				{
					path: "start-free-trial-and-login",
					component: () =>
						import("./components/loginAndFreeTrial/LoginAndFreeTrial.vue"),
				},
				{
					path: "user-information",
					component: () =>
						import("./views/userInformation/UserInformation.vue"),
				},
				{
					path: "account-type",
					component: () => import("./views/accountType/AccountType.vue"),
				},
				{
					path: "finish-setup",
					component: () => import("./views/finishSetUp/FinishSetUp.vue"),
				},
				{
					path: "email-reset-password",
					component: () =>
						import("./components/emailResetPassword/EmailResetPassword.vue"),
				},
				{
					path: "resend-activation",
					component: () =>
						import("./components/resendActivation/ResendActivation.vue"),
				},
				{
					path: "/login",
					name: "login",
					component: () => import("./components/Login/Login.vue"),
				},
				{
					path: "/reset-password-by-email",
					name: "reset-password-by-email",
					component: () => import("./components/Login/Login.vue"),
				},
			],
		},
		{
			path: "/:catchAll(.*)",
			name: "Not Found",
			component: NotFound,
		},
	],
});

// auth guards
router.beforeEach((to, from, next) => {
	if (to.matched.some((record) => record.meta.requiresAuth)) {
		// console.log('secured route...');
		try {
			var token = localStorage.getItem("x-access-token");

			if (token) {
				// console.log('Authorized access...');
				let last_visited_route = localStorage.getItem("last_visited_route");
				let last_visited_route_query = localStorage.getItem("last_visited_route_query");
				if (last_visited_route) {
					localStorage.removeItem("last_visited_route");
					next({ path: last_visited_route, query: JSON.parse(last_visited_route_query)});
				} else {
					next();
				}

				next();
			} else {
				console.log(to, from, next);
				localStorage.setItem("last_visited_route", to.path);
				localStorage.setItem("last_visited_route_query", JSON.stringify(to.query));
				// console.log('Token is missing, unathorized access - redirecting to landing page');
				document.getElementById("app").style.marginLeft = "0";
				next("/");
			}
		} catch (e) {
			// console.log('EXCEPTION: in validating access', e);
			const r_email = localStorage.getItem('r_email');
            localStorage.clear();
            if(r_email){
              localStorage.setItem('r_email', r_email);
            }
			document.getElementById("app").style.marginLeft = "0";
			next("/");
		}
	} else {
		if (to.name === "Home" || to.name === "login") {
			try {
				var token = localStorage.getItem("x-access-token");
				var user_email = localStorage.getItem("user_email");
				if (token) {
					// console.log('auto login redirecting to home...');
					if (
						user_email &&
						user_email.toLowerCase().indexOf("@theobroma.in") !== -1
					) {
						next({ name: "Tasks" });
					} else {
						next({ name: "SchedulePlanner" });
					}
				} else {
					//redirecting to landing page
					// console.log('old login session not present...');
					document.getElementById("app").style.marginLeft = "0";
					next();
				}
			} catch (e) {
				//redirecting to landing page
				// console.log('exception getting login session...', e);
				const r_email = localStorage.getItem('r_email');
				localStorage.clear();
				if(r_email){
				localStorage.setItem('r_email', r_email);
				}
				document.getElementById("app").style.marginLeft = "0";
				next();
			}
		} else {
			next();
		}
	}
});

// router.beforeEach((to, from, next) => {
// 	NProgress.start();
// 	next();
// });

// router.afterEach(() => {
// 	window.scrollTo(0, 0);
// 	// NProgress.done();
// });

router.afterEach(() => {
	//start page with top
	window.scrollTo(0, 0);
});

const scrollBehavior = function (to, from, savedPosition) {
	if (savedPosition) {
		return savedPosition;
	} else {
		return { x: 0, y: 0 };
	}
};
export default router;
